import React, { useEffect, useRef, useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TextInput,
  TouchableOpacity,
  ActivityIndicator,
  Dimensions,
  Animated,
  Image,
  Pressable,
} from "react-native";
import Victory from "../../constants/victory";
import Icon from "react-native-vector-icons/MaterialIcons";
import FeatherIcon from "react-native-vector-icons/Feather";
import FontAwesome from "react-native-vector-icons/FontAwesome";
import FontAwesome5 from "react-native-vector-icons/FontAwesome5";
import { fetchBermadData } from "./bermadApiCall";
import { ScrollView, FlatList } from "react-native";
import { Dropdown } from "react-native-element-dropdown";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { baseUrl, postData } from "../../networking/api";
import DataTable from "react-data-table-component";
import { useFocusEffect } from "@react-navigation/native";
import IconSelect from "react-native-vector-icons/AntDesign";
import moment from "moment";

const HomeScreen = ({ navigation }: { navigation: any }) => {
  const [rtuList, setRtuList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubZoneLoading, setIsSubZoneLoading] = useState(true);

  // Pagination states
  const optionsPerPage = [10, 25, 50, 100];
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(optionsPerPage[0]);
  const [totalRows, setTotalRows] = useState(0);
  const [OmegaIdData, setOmegaIdData] = useState([]);
  // Dropdown states
  const [ZoneNameData, setZoneNameData] = useState([]);
  const [ZoneValue, setZoneValue] = useState("All");
  const [ZoneValueId, setZoneValueId] = useState(0);
  const [SubzoneValue, setSubzoneValue] = useState("All");
  const [SubzoneValueId, setSubzoneValueId] = useState(0);
  const [subzoneData, setSubzoneData] = useState([]);
  const [showSubzoneDropdown, setShowSubzoneDropdown] = useState(false);
  const [showOmgegaDropdown, setShowOmegaDropdown] = useState(true);

  const [userTokenValue, setUserTokenValue] = useState("");
  const [projectId, setProjectId] = useState("");
  const [userType, setUserType] = useState();
  const [rtuSearchQuery, setRtuSearchQuery] = useState("");
  const [filteredRtuList, setFilteredRtuList] = useState([]);
  const [isAdd, setisAdd] = useState(false);

  // Combined dashboard states
  const [combinedDashboardData, setCombinedDashboardData] = useState(null);
  const [rtuStatusData, setRtuStatusData] = useState(null);
  const [energyStatusData, setEnergyStatusData] = useState(null);
  const [flowStatusData, setFlowStatusData] = useState(null);

  // Valve status states
  const [valveData, setValveData] = useState([]);
  const [valveTotal, setValveTotal] = useState(0);
  const [valveDashboardName, setValveDashboardName] = useState("");

  //water meter data
  const [waterMeterData, setWaterMeterData] = useState([]);
  const [switchStatusData, setSwitchStatusData] = useState([]);
  const [barGraphData, setBarGraphData] = useState([]);
  const [sensorData, setSensorData] = useState([]);

  const [loader, setLoader] = useState(true);

  // Dashboard access state
  const [dashboardAccess, setDashboardAccess] = useState([]);
  const [dashboardAccessLoaded, setDashboardAccessLoaded] = useState(false);

  const [boxLoading, setBoxLoading] = useState(true);
  const [switchLoading, setSwitchLoading] = useState(true);
  const [valveLoading, setValveLoading] = useState(true);
  const [rtuLoading, setRtuLoading] = useState(true);
  const [bargraphLoading, setBargraphLoading] = useState(true);
  const [OmegaValue, setOmegaValue] = useState<any>({});
  const [OmegavalueId, setOmegaValueiD] = useState("");
  const [OmegaIdValue, setOmegaIdValue] = useState<null | string>(null);

  const { width: screenWidth, height: screenHeight } = Dimensions.get("window");

  useFocusEffect(
    React.useCallback(() => {
      const loadCachedData = async () => {
        try {
          const cached = await AsyncStorage?.getItem("cachedDashboard");
          const projValueID = await AsyncStorage.getItem("projectData");
          if (cached) {
            const data = JSON.parse(cached);
            await showDashboardDynamically();
            await getZoneData();

            // ✅ Restore cached data
            setCombinedDashboardData(data?.combinedDashboardData || []);
            setRtuStatusData(
              data?.combinedDashboardData?.RTUDeviceStatus || null,
            );
            setEnergyStatusData(
              data?.combinedDashboardData?.EnergyStatus || null,
            );
            setFlowStatusData(data?.combinedDashboardData?.FlowStatus || null);
            setRtuList(data?.rtuList || []);
            setValveData(data?.valveData?.valveData || []);
            setValveTotal(data?.valveData?.total);
            setValveDashboardName(data?.valveData?.dashboardName);
            setBarGraphData(data?.barGraphData || []);
            setWaterMeterData(data?.waterMeterData || []);
            setSensorData(data?.sensorData || []);
            setSwitchStatusData(data?.switchStatusData || []);

            // ✅ Disable all loaders so UI shows instantly
            setBoxLoading(false);
            setRtuLoading(false);
            setValveLoading(false);
            setSwitchLoading(false);
            setBargraphLoading(false);

            console.log("✅ Cached dashboard loaded successfully");
          } else {
            console.log("⚙️ No cache found, calling API");

            await getAdminData();
          }
        } catch (error) {
          console.log("❌ Error loading cached data:", error);

          await getAdminData();
        }
      };

      loadCachedData();
    }, [userType]),
  );
  // loader code

  // Manual reload function for when user explicitly wants to refresh
  const handleManualReload = async () => {
    await AsyncStorage.removeItem("cachedDashboard");
    await getAdminData();
  };
  // Add reload button component
  const ReloadButton = () => (
    <TouchableOpacity style={styles.reloadButton} onPress={handleManualReload}>
      <Icon name="refresh" size={20} color="#fff" />
      <Text style={styles.reloadText}>Refresh</Text>
    </TouchableOpacity>
  );

  // Function to check if dashboard should be shown
  // Function to check if dashboard should be shown
  const shouldShowDashboard = (dashboardId: any) => {
    if (!dashboardAccessLoaded) return true;

    const dashboard = dashboardAccess.find(
      (item) => item?.dashboard_id == dashboardId,
    );

    // Check if dashboard access is enabled
    if (!dashboard || dashboard?.is_access != 1) {
      return false;
    }

    // Additional checks for specific dashboards based on data availability
    switch (dashboardId) {
      case 1: // RTU ONLINE
      case 2: // RTU OFFLINE
      case 3: // LOW BATTERY
      case 4: // CRITICAL BATTERY
      case 6: // FLOW STATUS
        return combinedDashboardData !== null;

      case 5: // VALVE STATUS
        return valveData;

      case 7: // WATER METER ALERTS
        return waterMeterData;

      case 8: // SENSOR ALERTS
        return sensorData;

      case 9: // RTU LIST
        return filteredRtuList;

      case 10: // SWITCH STATUS
        return switchStatusData;

      case 11: // BAR GRAPH
        return barGraphData;

      default:
        return false;
    }
  };

  // show dashboard dynamically
  const showDashboardDynamically = async () => {
    try {
      let jsonValue = await AsyncStorage.getItem("userData");
      var userDetailsresponse = JSON.parse(jsonValue);
      var default_project_id = "";

      if (userType == 1) {
        default_project_id = userDetailsresponse.project_selected;
      } else {
        default_project_id = userDetailsresponse.project_id;
      }

      let projValue = await AsyncStorage.getItem("projectData");

      const projectIdToUse = projValue || default_project_id;

      if (!projectIdToUse) {
        setDashboardAccessLoaded(true);
        return;
      }

      const payload = {
        project_id: projectIdToUse,
      };
      const apiUrl = `${baseUrl}masters/getProjectWiseDashboardAccess`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: userTokenValue,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responseData = await response.json();

      if (responseData.code === 1) {
        setDashboardAccess(responseData.data);
        setDashboardAccessLoaded(true);
        return responseData.data;
      } else {
        console.log("Failed to fetch dashboard access");
        setDashboardAccessLoaded(true);
        return [];
      }
    } catch (error) {
      console.error("Error fetching dashboard access:", error);
      setDashboardAccessLoaded(true);
      return [];
    }
  };

  const rtuColumns = [
    {
      name: "CONTROLLER",
      selector: (row) => row.unitName || "N/A",
      sortable: true,
      width: "30%",
      cell: (row) => (
        <View style={styles.controllerCell}>
          <FeatherIcon
            name="wifi"
            size={16}
            color={
              row.onlineStatus?.toUpperCase() === "ONLINE" ? "green" : "red"
            }
            style={styles.wifiIcon}
          />
          <Text style={styles.controllerText}>{row.unitName || "N/A"}</Text>
        </View>
      ),
      style: {
        justifyContent: "flex-start",
        alignItems: "center",
      },
    },
    {
      name: "ONLINE STATUS",
      selector: (row) => (row.onlineStatus === "ONLINE" ? "Online" : "Offline"),
      sortable: true,
      width: "15%",
      cell: (row) => (
        <View style={styles.statusCell}>
          {row.onlineStatus === "ONLINE" ? (
            <Text style={[styles.statusText, { color: "green" }]}>Online</Text>
          ) : (
            <View style={styles.lastConnectionContainer}>
              <Text style={styles.lastConnectionDate}>
                {formatDate(row.lastConnection)}
              </Text>
              <Text style={styles.lastConnectionTime}>
                {formatTime(row.lastConnection)}
              </Text>
            </View>
          )}
        </View>
      ),
      style: {
        justifyContent: "flex-start",
        alignItems: "center",
      },
    },
    {
      name: "",
      width: "55%",
      cell: (row) => {
        const hasValves = row.valves?.length > 0;
        const hasWaterMeters = row.watermeters?.length > 0;
        const hasSwitches = row.switches?.length > 0;
        const hasAnalogs = row.analogs?.length > 0;

        if (!hasValves && !hasWaterMeters && !hasSwitches && !hasAnalogs) {
          return null;
        }

        return (
          // <ScrollView
          //   horizontal
          //   showsHorizontalScrollIndicator={true}
          //   style={styles.combinedScrollContainer}
          //   contentContainerStyle={styles.combinedScrollContent}
          // >
          <View
            onMouseEnter={(e) => {
              e.currentTarget.style.overflowX = "auto";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.overflowX = "hidden";
            }}
            style={{
              width: "100%",
              overflowX: "hidden",
              overflowY: "hidden",
              paddingBottom: 2,
              whiteSpace: "nowrap",
              scrollbarColor: "#006eb9 #f0f0f0",
              scrollbarWidth: "thin",
            }}
            dangerouslySetInnerHTML={{
              __html: `<style>
      .custom-scroll::-webkit-scrollbar {
        height: 1px;
      }
      .custom-scroll::-webkit-scrollbar-track {
        background: #f0f0f0;
      }
      .custom-scroll::-webkit-scrollbar-thumb {
        background-color: #006eb9;
        border-radius: 1px;
      }
      .custom-scroll::-webkit-scrollbar-thumb:hover {
        background-color: #006eb9;
      }
    </style>`,
            }}
            className="custom-scroll"
          >
            <View style={styles.badgeRow}>
              {" "}
              {/* Valves  */}
              {hasValves &&
                row.valves.map((valve, index) => (
                  <View key={`valve-${index}`} style={styles.badge}>
                    <Text style={styles.badgeLabel}>{valve.name}</Text>
                    <Text style={styles.badgeValue}>{valve.state}</Text>
                  </View>
                ))}
              {/* Water Meters  */}
              {hasWaterMeters &&
                row.watermeters.map((meter, index) => (
                  <View key={`meter-${index}`} style={styles.badge}>
                    <Text style={styles.badgeLabel}>{meter.name}</Text>
                    <Text style={styles.badgeValue}>
                      {formatTotalizer(meter.totalizer)}
                    </Text>
                  </View>
                ))}
              {hasWaterMeters &&
                row.watermeters.map((meter, index) => (
                  <View key={`meter-${index}`} style={styles.badge}>
                    <Text style={styles.badgeLabel}>{meter?.name}</Text>
                    <Text style={styles.badgeValue}>{meter?.flow} m³</Text>
                  </View>
                ))}
              {/* Switches  */}
              {hasSwitches &&
                row.switches.map((switches, index) => (
                  <View key={`switch-${index}`} style={styles.badge}>
                    <Text style={styles.badgeLabel}>{switches.name}</Text>
                    <Text style={styles.badgeValue}>{switches.value}</Text>
                  </View>
                ))}
              {/* Tank Levels */}
              {hasAnalogs &&
                row.analogs.map((analog, index) => (
                  <View key={`tank-${index}`} style={styles.badge}>
                    <Text style={styles.badgeLabel}>{analog.name}</Text>
                    <Text style={styles.badgeValue}>
                      {analog.value ? `${analog.value}` : "0"}
                    </Text>
                  </View>
                ))}
            </View>
          </View>
          // </ScrollView>
        );
      },
      style: {
        justifyContent: "center",
        alignItems: "center",
      },
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "35px",
        fontSize: 10,
        borderBottomWidth: 1,
        borderBottomColor: "#e0e0e0",
        fontFamily: "sans-serif",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#fff",
        minHeight: "30px",
        fontSize: 9,
        fontWeight: "500",
        borderBottomWidth: 1,
        borderBottomColor: "#e0e0e0",
        borderTopWidth: 0,
      },
    },
    headCells: {
      style: {
        justifyContent: "flex-start",
        alignItems: "center",
        minHeight: "30px",
        fontSize: 12,
        paddingLeft: "2px",
        paddingRight: "2px",
        fontWeight: "bold",
        fontFamily: "sans-serif",
        color: "#333333",
        "&:not(:last-of-type)": {
          borderRightStyle: "none",
          borderRightWidth: 0,
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "2px",
        paddingRight: "2px",
        justifyContent: "flex-start",
        fontSize: 9,
        "&:not(:last-of-type)": {
          borderRightStyle: "none",
          borderRightWidth: 0,
          fontWeight: "400",
        },
      },
    },
    pagination: {
      style: {
        fontSize: 10,
      },
    },
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const formatTime = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`;
  };

  const formatTotalizer = (value) => {
    if (!value && value !== 0) return "0 m³";

    const cubicMeters = value / 1000;

    return `${cubicMeters.toLocaleString("en-US", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    })} m³`;
  };

  const handleRtuSearch = (query) => {
    setRtuSearchQuery(query);
    if (query.trim() === "") {
      setFilteredRtuList(rtuList);
    } else {
      const filtered = rtuList.filter(
        (item) =>
          item.unitName?.toLowerCase().includes(query.toLowerCase()) ||
          // (item.isOnline ? "online" : "offline").includes(query.toLowerCase()),
          (item.onlineStatus || "").toLowerCase().includes(query.toLowerCase()),
      );
      setFilteredRtuList(filtered);
    }
  };

  useEffect(() => {
    const fetchUserType = async () => {
      try {
        const userTypeValue = await AsyncStorage.getItem("userTypes");
        if (userTypeValue !== null) {
          setUserType(JSON.parse(userTypeValue));
        }
      } catch (error) {
        console.error("Error fetching userType from AsyncStorage:", error);
      }
    };
    fetchUserType();
  }, []);

  useEffect(() => {
    setFilteredRtuList(rtuList);
    setTotalRows(rtuList?.length);
  }, [rtuList]);
  const getZoneData = async () => {
    let jsonValue = await AsyncStorage.getItem("userData");
    var userDetailsresponse = JSON.parse(jsonValue);
    var default_project_id = "";

    if (userType == 1) {
      default_project_id = userDetailsresponse.project_selected;
    } else {
      default_project_id = userDetailsresponse.project_id;
    }

    let projValue = await AsyncStorage.getItem("projectData");
    const userToken = await AsyncStorage.getItem("userToken");
    setUserTokenValue(userToken);

    // if (!projValue) return;
    if (projValue != null || default_project_id != null) {
      const activeProjectId = projValue ?? default_project_id;
      // ✅ Set up the selected project
      setProjectId(activeProjectId);

      setZoneValueId(0);
      setShowSubzoneDropdown(false);
      getAllZoneProfileData(activeProjectId);
      getOmegaDependentByProjectId(activeProjectId, 0, 0);
    }
  };

  const getAdminData = async () => {
    let jsonValue = await AsyncStorage.getItem("userData");
    var userDetailsresponse = JSON.parse(jsonValue);
    var default_project_id = "";

    if (userType == 1) {
      default_project_id = userDetailsresponse.project_selected;
    } else {
      default_project_id = userDetailsresponse.project_id;
    }

    let projValue = await AsyncStorage.getItem("projectData");
    const userToken = await AsyncStorage.getItem("userToken");
    setUserTokenValue(userToken);

    // if (!projValue) return;
    if (projValue != null || default_project_id != null) {
      try {
        const activeProjectId = projValue ?? default_project_id;
        // ✅ Set up the selected project
        await showDashboardDynamically();
        setProjectId(activeProjectId);
        getAllZoneProfileData(activeProjectId);
        getOmegaDependentByProjectId(activeProjectId, 0, 0);

        // ⚡ Run all API calls in parallel
        // const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

        const [
          combinedData,
          valveDataFetched,
          waterMeterFetched,
          switchFetched,
          barGraphFetched,
          sensorFetched,
          rtuListFetched,
        ] = await Promise.all([
          shouldShowDashboard(1) ||
          shouldShowDashboard(2) ||
          shouldShowDashboard(3) ||
          shouldShowDashboard(4) ||
          shouldShowDashboard(6)
            ? fetchCombinedDashboard(activeProjectId, userToken, 0, 0)
            : Promise.resolve([]),

          shouldShowDashboard(5)
            ? fetchValveStatus(activeProjectId, userToken, 0, 0)
            : Promise.resolve([]),

          shouldShowDashboard(7)
            ? fetchWaterMeterDashboard(activeProjectId, userToken, 0, 0)
            : Promise.resolve([]),

          shouldShowDashboard(10)
            ? fetchSwitchStatusDashboard(activeProjectId, userToken, 0, 0)
            : Promise.resolve([]),

          shouldShowDashboard(11)
            ? fetchBarGraphData(activeProjectId, userToken, 0, 0, 0)
            : Promise.resolve([]),

          shouldShowDashboard(8)
            ? fetchSensorDashboard(activeProjectId, userToken, 0, 0)
            : Promise.resolve([]),
          shouldShowDashboard(9) ? loadBermadData() : Promise.resolve([]),
        ]);

        // if (combinedData) {
        //   setCombinedDashboardData(combinedData);
        //   setRtuStatusData(combinedData?.RTUDeviceStatus);
        //   setEnergyStatusData(combinedData?.EnergyStatus);
        //   setFlowStatusData(combinedData?.FlowStatus);
        // }

        // setValveData(valveDataFetched?.valveData);
        // setValveTotal(valveDataFetched?.total);
        // setValveDashboardName(valveDataFetched?.dashboardName);
        // setWaterMeterData(waterMeterFetched);
        // setSwitchStatusData(switchFetched);
        // setBarGraphData(barGraphFetched);
        // setSensorData(sensorFetched);
        // setRtuList(rtuListFetched);

        await AsyncStorage.setItem(
          "cachedDashboard",
          JSON.stringify({
            combinedDashboardData: combinedData,
            rtuList: rtuListFetched,
            valveData: valveDataFetched,
            barGraphData: barGraphFetched,
            waterMeterData: waterMeterFetched,
            sensorData: sensorFetched,
            switchStatusData: switchFetched,
          }),
        );

        setBoxLoading(false);
        setRtuLoading(false);
        setValveLoading(false);
        setSwitchLoading(false);
        setBargraphLoading(false);

        console.log("✅ All dashboard data fetched and cached successfully");
      } catch (error) {
        console.log("❌ Error fetching dashboard data:", error);
      }
    }
  };

  const zoneAndSubzoneWiseDashborad = (
    projectId,
    userTokenValue,
    zoneId,
    subzoneId,
  ) => {
    // Conditionally call APIs based on dashboard access
    if (
      shouldShowDashboard(1) ||
      shouldShowDashboard(2) ||
      shouldShowDashboard(3) ||
      shouldShowDashboard(4) ||
      shouldShowDashboard(6)
    ) {
      fetchCombinedDashboard(projectId, userTokenValue, zoneId, subzoneId);
    }
    if (shouldShowDashboard(5)) {
      fetchValveStatus(projectId, userTokenValue, zoneId, subzoneId);
    }
    if (shouldShowDashboard(7)) {
      fetchWaterMeterDashboard(projectId, userTokenValue, zoneId, subzoneId);
    }
    if (shouldShowDashboard(10)) {
      fetchSwitchStatusDashboard(projectId, userTokenValue, zoneId, subzoneId);
    }
    if (shouldShowDashboard(11)) {
      const selectedOmegaId = OmegaValue?.omega_id || 0;
      fetchBarGraphData(
        projectId,
        userTokenValue,
        zoneId,
        subzoneId,
        selectedOmegaId,
      );
    }
    if (shouldShowDashboard(8)) {
      fetchSensorDashboard(projectId, userTokenValue, zoneId, subzoneId);
    }
  };

  // Combined Dashboard API function
  const fetchCombinedDashboard = async (
    projectId,
    userToken,
    zoneId = 0,
    subzoneId = 0,
  ) => {
    setBoxLoading(true);
    try {
      const apiUrl = `${baseUrl}new-dashboards/dashboard-combine/${projectId}/${zoneId}/${subzoneId}`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: userToken,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responseData = await response.json();

      if (responseData.code === 1) {
        const data = responseData.data;
        setCombinedDashboardData(data);
        setRtuStatusData(data.RTUDeviceStatus || null);
        setEnergyStatusData(data.EnergyStatus || null);
        setFlowStatusData(data.FlowStatus || null);
        return data;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error fetching combined dashboard:", error);
      return null;
    } finally {
      setBoxLoading(false);
    }
  };

  const loadBermadData = async () => {
    setRtuLoading(true);
    try {
      const data = await fetchBermadData();

      setRtuList(data?.realtimeTable?.unitsStatusTable || []);
      return data?.realtimeTable?.unitsStatusTable || [];
    } catch (err) {
      console.error("Error fetching Bermad data:", err);
    } finally {
      setRtuLoading(false);
    }
  };

  // Get Zone Data
  const getAllZoneProfileData = async (pid) => {
    setLoading(true);
    try {
      var getZoneData = JSON.stringify({
        condition: {
          project_id: pid,
        },
        module: "zone_master",
        relation: [],
        active: 1,
      });
      const ZoneNameResponse = await postData(
        getZoneData,
        "masters/getMasterList",
      );
      var code = ZoneNameResponse.code;
      if (code == 1) {
        var mergeDataDrop = ZoneNameResponse.data;
        mergeDataDrop.unshift({
          zone_name: "All",
          active: 1,
          id: 0,
        });
        setZoneValue("All");
        setZoneNameData(mergeDataDrop);
      } else {
        // setLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Get Subzone Data
  const getDependentZoneMaster = async (zone_id) => {
    try {
      var dependentData = JSON.stringify({
        column: "zone_id",
        value: zone_id,
        module: "sub_zone_master",
      });
      setIsSubZoneLoading(true);

      const dependentZoneRes = await postData(
        dependentData,
        "masters/getDependentMasterList",
      );
      var code = dependentZoneRes.code;
      if (code == 1) {
        var mergeDataSubDrop = dependentZoneRes.data;
        mergeDataSubDrop.unshift({
          sub_zone_name: "All",
          active: 1,
          id: 0,
        });
        setSubzoneData(mergeDataSubDrop);
      } else {
      }
    } catch (error) {
    } finally {
      setIsSubZoneLoading(false);
    }
  };
  const getOmegaDependentByProjectId = async (
    projectID,
    zone_id,
    sub_zone_id,
  ) => {
    setIsLoading(true);
    try {
      var OmegaIdData = JSON.stringify({
        column: "project_id",
        value: projectID,
        module: "devices_master",
        zone_id: zone_id,
        sub_zone_id: sub_zone_id,
        isUpdate: true,
      });
      const OmegaIdList = await postData(
        OmegaIdData,
        "masters/getDependentMasterList",
        // "masters/getOmegaFromBermad"
      );
      var code = OmegaIdList.code;
      if (code == 1) {
        var mergeData = OmegaIdList.data;
        mergeData.unshift({
          id: 0,
          project_id: projectId,
          omega_id: "",
          device_name: "All",
          lat: "",
          long: "",
          active: 1,
        });
        setOmegaIdValue("All");
        // setOmegaValueiD(0);
        setOmegaIdData(mergeData);
      } else {
        // //alert(OmegaIdList.message);
      }
    } catch (error) {
      // console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  // Render functions for dropdown items
  const renderZoneIdListItems = (item: any) => {
    return (
      <View style={styles.item}>
        <Text style={styles.textItem}>{item.zone_name}</Text>
      </View>
    );
  };

  const renderSubZoneIdListItems = (item: any) => {
    return (
      <View style={styles.item}>
        <Text style={styles.textItem}>{item.sub_zone_name}</Text>
      </View>
    );
  };
  const renderOmegaIdListItems = (item: any) => {
    return (
      <TouchableOpacity
        style={styles.item}
        onPress={() => {
          window.open(
            `/ValveView?OmegaId=${item?.omega_id}&OmegaName=${item?.device_name}&basedOn=${item?.based_on}`,
            "_blank",
          );
        }}
      >
        <Text style={styles.textItem}>{item.device_name}</Text>

        {item.id === OmegavalueId && (
          <Icon style={styles.icon} color="black" name="Safety" size={20} />
        )}
      </TouchableOpacity>
    );
  };

  // Valve Status API function
  const fetchValveStatus = async (projectId, userToken, zoneId, subzoneId) => {
    try {
      setValveLoading(true);
      const apiUrl = `${baseUrl}new-dashboards/valvesDash/${projectId}/${zoneId}/${subzoneId}`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: userToken,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const responseData = await response.json();
      const valveData = responseData.data.valvesResponse;
      const colors = responseData.data.color;
      const dashboardName = responseData.data.dashboard_name;

      const filteredValveData = valveData.map((item, index) => ({
        x: item.statusName,
        y: item.x,
        color: colors[index],
        status: item.status,
      }));
      const total = valveData.reduce((sum, item) => sum + item.x, 0);
      setValveData(filteredValveData);
      setValveTotal(total);
      setValveDashboardName(dashboardName);
      return {
        valveData: filteredValveData,
        total: total,
        dashboardName: dashboardName,
      };
    } catch (error) {
      return null;
    } finally {
      setValveLoading(false);
    }
  };

  // Water Meter Dashboard
  const fetchWaterMeterDashboard = async (
    projectId,
    userToken,
    zoneId,
    subzoneId,
  ) => {
    setSwitchLoading(true);
    try {
      const apiUrl = `${baseUrl}new-dashboards/watermeterDash/${projectId}/${zoneId}/${subzoneId}`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: userToken,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responseData = await response.json();
      const data = responseData.data;

      setWaterMeterData(data);
      return data;
    } catch (error) {
      console.error("Error fetching water meter dashboard:", error);
      setWaterMeterData(null);
      return null;
    } finally {
      setSwitchLoading(false);
    }
  };

  //Switch dashboard
  const fetchSwitchStatusDashboard = async (
    projectId,
    userToken,
    zoneId,
    subzoneId,
  ) => {
    setSwitchLoading(true);
    try {
      const apiUrl = `${baseUrl}new-dashboards/switchesDash/${projectId}/${zoneId}/${subzoneId}`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: userToken,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responseData = await response.json();

      const data = responseData.data;

      setSwitchStatusData(data);
      return data;
    } catch (error) {
      console.error("Error fetching switch dashboard:", error);
      setSwitchStatusData(null);
      return null;
    } finally {
      setSwitchLoading(false);
    }
  };

  // Sensor Dashboard
  const fetchSensorDashboard = async (
    projectId,
    userToken,
    zoneId = 0,
    subzoneId = 0,
  ) => {
    setSwitchLoading(true);
    try {
      const apiUrl = `${baseUrl}new-dashboards/analogNew/${projectId}/${zoneId}/${subzoneId}`;
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: userToken,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responseData = await response.json();

      const data = responseData.data;
      setSensorData(data);
      return data;
    } catch (error) {
      console.error("Error fetching sensor dashboard:", error);
      setSensorData(null);
      return [];
    } finally {
      setSwitchLoading(false);
    }
  };

  // Bar Graph function
  const fetchBarGraphData = async (
    projectId,
    userToken,
    zoneId,
    subzoneId,
    omegaId = 0,
  ) => {
    setBargraphLoading(true);
    try {
      const apiUrl = `${baseUrl}new-dashboards/water-delivery-vs-demand/${projectId}/${zoneId}/${subzoneId}/${omegaId}`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: userToken,
        },
      });
      const responseData = await response.json();
      if (responseData.code === 1) {
        const data = responseData.data;
        const formattedResults = data?.results?.map((item) => ({
          ...item,
          formattedDate: moment(item.date).format("D-M-YY"),
        }));

        const formattedData = {
          dashboard_name: data?.dashboard_name,
          results: formattedResults,
        };

        setBarGraphData(formattedData);
        setBargraphLoading(false);

        return formattedData;
      } else {
        setBarGraphData([]);
        return [];
      }
    } catch (error) {
      console.error("Error fetching bar graph data:", error);
      setBarGraphData([]);
      return [];
    } finally {
      setBargraphLoading(false);
    }
  };

  const handleRTUOnlineNavigation = () => {
    try {
      const onlineDevice = rtuStatusData?.deviceStatusResponse?.find(
        (device) => device.status === true,
      );
      if (onlineDevice) {
        navigation.navigate("DeviceDetailsReport", {
          isOnline: onlineDevice.status,
          zoneId: ZoneValueId,
          subzoneId: SubzoneValueId,
        });
      }
    } catch (error) {
      console.error("Navigation error:", error);
    }
  };

  const handleRTUOfflineNavigation = () => {
    try {
      const offlineDevice = rtuStatusData?.deviceStatusResponse?.find(
        (device) => device.status === false,
      );
      if (offlineDevice) {
        navigation.navigate("DeviceDetailsReport", {
          isOnline: offlineDevice.status,
          zoneId: ZoneValueId,
          subzoneId: SubzoneValueId,
        });
      }
    } catch (error) {
      console.error("Navigation error:", error);
    }
  };

  const handleLowBatteryNavigation = () => {
    try {
      navigation.navigate("EnergyStatusDetailReport", {
        status: "low_battery",
        zoneId: ZoneValueId,
        subzoneId: SubzoneValueId,
      });
    } catch (error) {
      console.error("Navigation error:", error);
    }
  };

  const handleCriticalBatteryNavigation = () => {
    try {
      navigation.navigate("EnergyStatusDetailReport", {
        status: "critical_low_battery",
        zoneId: ZoneValueId,
        subzoneId: SubzoneValueId,
      });
    } catch (error) {
      console.error("Navigation error:", error);
    }
  };
  const formatValue = (value) => {
    if (value === null || value === undefined) return "";

    const num = Number(value);

    if (num > 999) {
      return (num / 1000).toFixed(1) + "K";
    }

    return num.toLocaleString("en-IN");
  };

  const handleSwitchNavigation = (dashboardItem: any, specificSwitch: any) => {
    try {
      navigation.navigate("DigitalInputsReport", {
        status: specificSwitch?.status,
        index: specificSwitch?.index,
        zoneId: ZoneValueId,
        title: dashboardItem.title,
        subzoneId: SubzoneValueId,
        statusName: specificSwitch?.statusName,
        dashboardItem: dashboardItem,
        specificSwitch: specificSwitch,
      });
    } catch (error) {
      console.error("Navigation error:", error);
    }
  };
  const handleSensorAlertNavigation = (dashboardItem: any) => {
    try {
      navigation.navigate("SensorDetailsReport", {
        status: dashboardItem?.status,
        index: dashboardItem?.index,
        title: dashboardItem.title,
        zoneId: ZoneValueId,
        subzoneId: SubzoneValueId,
      });
    } catch (error) {
      console.error("Navigation error:", error);
    }
  };

  const handleWaterMeterNavigation = (item: any) => {
    try {
      navigation.navigate("DigitalDetailsReport", {
        index: Number(item?.title?.match(/\d+$/)?.[0]) || 1,
        title: item?.title,
        zoneId: ZoneValueId,
        subzoneId: SubzoneValueId,
      });
    } catch (error) {
      console.log("Water meter navigation error:", error);
    }
  };

  const renderWaterMeterItem = ({ item }) => (
    <TouchableOpacity
      style={styles.waterMeterItem}
      onPress={() => handleWaterMeterNavigation(item)}
    >
      <View style={styles.iconContainer}>
        <Icon
          name={"water-damage"}
          size={10}
          color="#FFD700"
          style={{ marginTop: 4 }}
        />
        <Text style={styles.waterMeterTitle}>{item.title}</Text>
      </View>
      <View style={styles.alertRow}>
        <Text style={styles.alertType}>{item.alertType}</Text>
        <Text style={styles.alertValue}>{item.value}</Text>
      </View>
    </TouchableOpacity>
  );

  const renderSensorAlertItem = ({ item }) => {
    // const borderColor = item.icon == 'alert-triangle' ? "#e74c3c" : "#FFD700"
    return (
      <View style={[styles.waterMeterItem, { borderLeftColor: "#e74c3c" }]}>
        <View style={styles.iconContainer}>
          <FeatherIcon
            name={"alert-triangle"}
            size={10}
            color="#e74c3c"
            style={{ marginTop: 4 }}
          />
          <Text style={styles.waterMeterTitle}>{item.title}</Text>
        </View>
        <View style={styles.alertRow}>
          <TouchableOpacity
            style={styles.alertRow}
            onPress={() => handleSensorAlertNavigation(item)}
          >
            <Text style={[styles.alertType, { marginLeft: 10 }]}>
              {item.alertType}
            </Text>
            <Text style={[styles.alertValue, { marginLeft: 10 }]}>
              {item.value}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  };

  const renderSwitchStatusItem = ({ item }) => {
    return (
      <View style={[styles.waterMeterItem, { borderLeftColor: "#e74c3c" }]}>
        <View style={styles.iconContainer}>
          <FeatherIcon
            name={"alert-triangle"}
            size={10}
            color="#e74c3c"
            style={{ marginTop: 4 }}
          />
          <Text style={styles.waterMeterTitle}>{item.title}</Text>
        </View>

        {/* Make each switch response individually clickable */}
        {item.switchResponse?.map((switchItem, index) => (
          <TouchableOpacity
            key={index}
            style={styles.alertRow}
            onPress={() => handleSwitchNavigation(item, switchItem)}
          >
            <Text style={styles.alertType}>{switchItem?.statusName}</Text>
            <Text style={styles.alertValue}>{switchItem?.value}</Text>
          </TouchableOpacity>
        ))}
      </View>
    );
  };

  const renderRTUListSection = () => (
    <View style={styles.wideCardChart}>
      {rtuLoading ? (
        <View style={{ padding: 16 }}>
          <Skeleton
            width={300}
            height={40}
            borderRadius={8}
            style={{ marginBottom: 16 }}
          />

          <Skeleton
            width={650}
            height={20}
            borderRadius={4}
            style={{ marginBottom: 12, alignSelf: "center" }}
          />

          {[1, 2, 3, 4, 5].map((_, idx) => (
            <Skeleton
              key={idx}
              width={650}
              height={30}
              borderRadius={4}
              style={{ marginBottom: 10, alignSelf: "center" }}
            />
          ))}
        </View>
      ) : (
        <>
          <View style={styles.rtuSearchContainer}>
            <TextInput
              value={rtuSearchQuery}
              style={styles.rtuSearchInput}
              placeholder="Search"
              onChangeText={handleRtuSearch}
            />
          </View>

          <View style={styles.dataTableContainer}>
            <DataTable
              columns={rtuColumns}
              data={filteredRtuList}
              customStyles={customStyles}
              pagination
              paginationPerPage={itemsPerPage}
              paginationRowsPerPageOptions={optionsPerPage}
              onChangeRowsPerPage={(newPerPage) => setItemsPerPage(newPerPage)}
              onChangePage={(page) => setCurrentPage(page)}
              noHeader={false}
              fixedHeader
              fixedHeaderScrollHeight="280px"
              paginationComponentOptions={{
                rowsPerPageText: "Rows per page:",
                rangeSeparatorText: "of",
                noRowsPerPage: false,
              }}
            />
          </View>
        </>
      )}
    </View>
  );

  return (
    <View style={styles.container}>
      {/* Dropdown Section  */}
      <View style={{ flexDirection: "row", zIndex: 999 }}>
        <View style={{ marginLeft: "0.8%", width: "20%" }}>
          <View style={{ height: "14%" }}>
            {loading ? (
              <View
                style={{
                  marginTop: "2%",
                  width: "20%",
                  backgroundColor: "#fff",
                }}
              >
                <Skeleton width={250} height={30} borderRadius={6} />
              </View>
            ) : (
              <Dropdown
                style={styles.dropdown}
                placeholderStyle={styles.placeholderStyle}
                selectedTextStyle={styles.selectedTextStyle}
                inputSearchStyle={styles.inputSearchStyle}
                iconStyle={styles.iconStyle}
                data={ZoneNameData}
                search
                maxHeight={300}
                labelField="zone_name"
                valueField="zone_name"
                placeholder="Select Zone"
                searchPlaceholder="Search Zone..."
                value={ZoneValue}
                onChange={(item) => {
                  if (item.zone_name == "All") {
                    setZoneValue(item.zone_name);
                    setShowSubzoneDropdown(false);
                    setShowOmegaDropdown(false);
                  } else {
                    setZoneValue("All");
                    setShowSubzoneDropdown(true);
                  }
                  zoneAndSubzoneWiseDashborad(
                    projectId,
                    userTokenValue,
                    item.id,
                    0,
                  );
                  setZoneValueId(item.id);
                  getDependentZoneMaster(item.id);
                  getOmegaDependentByProjectId(projectId, item.id, 0);

                  // setZoneIdError("");
                }}
                renderItem={renderZoneIdListItems}
              />
            )}
          </View>
        </View>

        {showSubzoneDropdown && (
          <View style={{ marginLeft: "2%", width: "20%" }}>
            {isSubZoneLoading ? (
              <View
                style={{
                  marginTop: "2%",
                  width: "20%",
                  backgroundColor: "#fff",
                }}
              >
                <Skeleton width={250} height={30} borderRadius={6} />
              </View>
            ) : (
              <View>
                <Dropdown
                  style={styles.dropdown}
                  placeholderStyle={styles.placeholderStyle}
                  selectedTextStyle={styles.selectedTextStyle}
                  inputSearchStyle={styles.inputSearchStyle}
                  iconStyle={styles.iconStyle}
                  data={subzoneData}
                  search
                  maxHeight={300}
                  labelField="sub_zone_name"
                  valueField="sub_zone_name"
                  placeholder="Select Subzone..."
                  searchPlaceholder="Search Sub Zone"
                  value={SubzoneValue}
                  onChange={(item) => {
                    if (item.sub_zone_name == "All") {
                      setSubzoneValue(item.sub_zone_name);
                      setShowOmegaDropdown(false);
                    } else {
                      setSubzoneValue("All");
                      setShowOmegaDropdown(true);
                    }

                    setSubzoneValueId(item.id);
                    getOmegaDependentByProjectId(
                      projectId,
                      ZoneValueId,
                      item.id,
                    );

                    // setSubZoneIdError("");
                    zoneAndSubzoneWiseDashborad(
                      projectId,
                      userTokenValue,
                      ZoneValueId,
                      item.id,
                    );
                  }}
                  renderItem={renderSubZoneIdListItems}
                />
              </View>
            )}
          </View>
        )}
        {
          <View
            style={{
              marginLeft: "2%",
              width: "20%",
              backgroundColor: "#fff",
            }}
          >
            {isLoading ? (
              <View
                style={{
                  marginTop: "2%",
                  width: "20%",
                  backgroundColor: "#fff",
                }}
              >
                <Skeleton width={250} height={30} borderRadius={6} />
              </View>
            ) : (
              <Dropdown
                style={styles.dropdown}
                placeholderStyle={styles.placeholderStyle}
                selectedTextStyle={styles.selectedTextStyle}
                inputSearchStyle={styles.inputSearchStyle}
                iconStyle={styles.iconStyle}
                data={OmegaIdData}
                search
                maxHeight={300}
                labelField="device_name"
                valueField="device_name"
                placeholder="Omega Device"
                searchPlaceholder="Search Omega Device..."
                value={OmegaIdValue}
                onChange={(item) => {
                  setOmegaIdValue(item.device_name);
                  setOmegaValueiD(item.id);
                }}
                renderItem={renderOmegaIdListItems}
              />
            )}
          </View>
        }
        {/* Add Reload Button */}
        {/* Add Reload Button */}
        <ReloadButton />
      </View>

      <View style={styles.row}>
        <View style={{ flex: 1 }}>
          <View style={styles.cardsRow}>
            {/* RTU ONLINE Card - Dashboard ID: 1 */}
            {boxLoading ? (
              <View style={styles.cardSmall}>
                <View style={styles.cardHeader}>
                  <Skeleton
                    width={120}
                    height={15}
                    style={{ marginLeft: 10, marginTop: 5, marginBottom: 5 }}
                  />
                  <Skeleton
                    width={20}
                    height={20}
                    borderRadius={10}
                    style={{ marginLeft: "auto" }}
                  />
                </View>
                <View style={styles.cardContent}>
                  <Skeleton width={80} height={20} />
                  <Skeleton
                    width={40}
                    height={15}
                    style={{ marginTop: 10, alignSelf: "flex-start" }}
                  />
                </View>
              </View>
            ) : (
              shouldShowDashboard(1) && (
                <TouchableOpacity
                  style={styles.cardSmall}
                  onPress={handleRTUOnlineNavigation}
                >
                  <View style={styles.cardHeader}>
                    <Text
                      style={[
                        styles.cardTitle,
                        { marginLeft: 10, marginTop: 5 },
                      ]}
                    >
                      {
                        rtuStatusData?.deviceStatusResponse?.find(
                          (device) => device.status === true,
                        )?.title
                      }
                    </Text>

                    <FontAwesome
                      name="wifi"
                      size={16}
                      // color={
                      //   rtuStatusData?.deviceStatusResponse?.find(
                      //     device => device.status === true
                      //   )?.color
                      // }
                      color={"#009DF0"}
                      style={{ marginLeft: "auto", marginTop: 5 }}
                    />
                  </View>

                  <View style={styles.cardContent}>
                    <Text
                      style={[
                        styles.cardValue,
                        // {
                        //   color:
                        //     rtuStatusData?.deviceStatusResponse?.find(
                        //       device => device.status === true
                        //     )?.color,
                        // },
                        { color: "#009DF0" },
                      ]}
                    >
                      {
                        rtuStatusData?.deviceStatusResponse?.find(
                          (device) => device.status === true,
                        )?.count
                      }
                      <Text
                        style={{
                          fontSize: 14,
                          fontWeight: "400",
                          color: "#555",
                        }}
                      >
                        {" "}
                        of {rtuStatusData?.totalDevices || "0"}
                      </Text>
                    </Text>

                    <View
                      style={[
                        styles.batteryView,
                        // {
                        //   backgroundColor:
                        //     rtuStatusData?.deviceStatusResponse?.find(device => device.status === true)?.color,
                        // },
                        { backgroundColor: "#009DF0" },
                      ]}
                    >
                      <Text style={styles.cardPercent}>
                        {rtuStatusData?.deviceStatusResponse?.find(
                          (device) => device.status === true,
                        )?.percentage
                          ? `${
                              rtuStatusData.deviceStatusResponse.find(
                                (device) => device.status === true,
                              ).percentage
                            }%`
                          : "0%"}
                      </Text>
                    </View>
                  </View>
                </TouchableOpacity>
              )
            )}

            {/* RTU OFFLINE Card - Dashboard ID: 2 */}
            {boxLoading ? (
              <View style={styles.cardSmall}>
                <View style={styles.cardHeader}>
                  <Skeleton
                    width={120}
                    height={15}
                    style={{ marginLeft: 10, marginTop: 5, marginBottom: 5 }}
                  />
                  <Skeleton
                    width={20}
                    height={20}
                    borderRadius={10}
                    style={{ marginLeft: "auto" }}
                  />
                </View>
                <View style={styles.cardContent}>
                  <Skeleton width={80} height={20} />
                  <Skeleton
                    width={40}
                    height={15}
                    style={{ marginTop: 10, alignSelf: "flex-start" }}
                  />
                </View>
              </View>
            ) : (
              shouldShowDashboard(2) && (
                <TouchableOpacity
                  style={styles.cardSmall}
                  onPress={handleRTUOfflineNavigation}
                >
                  <View style={styles.cardHeader}>
                    <Text
                      style={[
                        styles.cardTitle,
                        { marginLeft: 10, marginTop: 5 },
                      ]}
                    >
                      {
                        rtuStatusData?.deviceStatusResponse?.find(
                          (device) => device.status === false,
                        )?.title
                      }
                    </Text>

                    <FontAwesome
                      name="wifi"
                      size={16}
                      color={
                        rtuStatusData?.deviceStatusResponse?.find(
                          (device) => device.status === false,
                        )?.color
                      }
                      style={{ marginLeft: "auto", marginTop: 5 }}
                    />
                  </View>

                  <View style={styles.cardContent}>
                    <Text
                      style={[
                        styles.cardValue,
                        {
                          color: rtuStatusData?.deviceStatusResponse?.find(
                            (device) => device.status === false,
                          )?.color,
                        },
                      ]}
                    >
                      {rtuStatusData?.deviceStatusResponse?.find(
                        (device) => device.status === false,
                      )?.count || "0"}
                    </Text>

                    <View
                      style={[
                        styles.batteryView,
                        {
                          backgroundColor:
                            rtuStatusData?.deviceStatusResponse?.find(
                              (device) => device.status === false,
                            )?.color || "grey",
                        },
                      ]}
                    >
                      <Text style={styles.cardPercent}>
                        {rtuStatusData?.deviceStatusResponse?.find(
                          (device) => device.status === false,
                        )?.percentage
                          ? `${
                              rtuStatusData.deviceStatusResponse.find(
                                (device) => device.status === false,
                              ).percentage
                            }%`
                          : "0%"}
                      </Text>
                    </View>
                  </View>
                </TouchableOpacity>
              )
            )}

            {/* LOW BATTERY ALERT Card - Dashboard ID: 3 */}
            {boxLoading ? (
              <View style={styles.cardSmall}>
                <View style={styles.cardHeader}>
                  <Skeleton
                    width={120}
                    height={15}
                    style={{ marginLeft: 10, marginTop: 5, marginBottom: 5 }}
                  />
                  <Skeleton
                    width={20}
                    height={20}
                    borderRadius={10}
                    style={{ marginLeft: "auto" }}
                  />
                </View>
                <View style={styles.cardContent}>
                  <Skeleton width={80} height={20} />
                  <Skeleton
                    width={40}
                    height={15}
                    style={{ marginTop: 10, alignSelf: "flex-start" }}
                  />
                </View>
              </View>
            ) : (
              shouldShowDashboard(3) && (
                <TouchableOpacity
                  style={styles.cardSmall}
                  onPress={handleLowBatteryNavigation}
                >
                  <View style={styles.cardHeader}>
                    <Text
                      style={[
                        styles.cardTitle,
                        { marginLeft: 10, marginTop: 5 },
                      ]}
                    >
                      {energyStatusData?.lowBattery?.title}
                    </Text>
                    <FontAwesome
                      name="battery-1"
                      size={16}
                      color="#FFD700"
                      style={{ marginLeft: "auto", marginTop: 5 }}
                    />
                  </View>
                  <View style={styles.cardContent}>
                    <Text style={[styles.cardValue, { color: "#FFD700" }]}>
                      {energyStatusData?.lowBattery?.count || "0"}
                    </Text>
                    <View
                      style={[
                        styles.batteryView,
                        { backgroundColor: "#FFD700" },
                      ]}
                    >
                      <Text style={styles.cardPercent}>
                        {energyStatusData?.lowBattery?.percent
                          ? `${energyStatusData.lowBattery.percent}%`
                          : "0%"}
                      </Text>
                    </View>
                  </View>
                </TouchableOpacity>
              )
            )}

            {/* CRITICAL BATTERY Card - Dashboard ID: 4 */}
            {boxLoading ? (
              <View style={styles.cardSmall}>
                <View style={styles.cardHeader}>
                  <Skeleton
                    width={120}
                    height={15}
                    style={{ marginLeft: 10, marginTop: 5, marginBottom: 5 }}
                  />
                  <Skeleton
                    width={20}
                    height={20}
                    borderRadius={10}
                    style={{ marginLeft: "auto" }}
                  />
                </View>
                <View style={styles.cardContent}>
                  <Skeleton width={80} height={20} />
                  <Skeleton
                    width={40}
                    height={15}
                    style={{ marginTop: 10, alignSelf: "flex-start" }}
                  />
                </View>
              </View>
            ) : (
              shouldShowDashboard(4) && (
                <TouchableOpacity
                  style={styles.cardSmall}
                  onPress={handleCriticalBatteryNavigation}
                >
                  <View style={styles.cardHeader}>
                    <Text
                      style={[
                        styles.cardTitle,
                        { marginLeft: 10, marginTop: 5 },
                      ]}
                    >
                      {energyStatusData?.criticalLowBattery?.title}
                    </Text>
                    <FontAwesome
                      name="battery-0"
                      size={16}
                      color="red"
                      style={{ marginLeft: "auto", marginTop: 5 }}
                    />
                  </View>
                  <View style={styles.cardContent}>
                    <Text style={[styles.cardValue, { color: "red" }]}>
                      {energyStatusData?.criticalLowBattery?.count || "0"}
                    </Text>
                    <View
                      style={[styles.batteryView, { backgroundColor: "red" }]}
                    >
                      <Text style={styles.cardPercent}>
                        {energyStatusData?.criticalLowBattery?.percent
                          ? `${energyStatusData.criticalLowBattery.percent}%`
                          : "0%"}
                      </Text>
                    </View>
                  </View>
                </TouchableOpacity>
              )
            )}

            {/* FLOW STATUS Card - Dashboard ID: 6 */}
            {boxLoading ? (
              <View style={styles.cardSmall}>
                <View style={styles.cardHeader}>
                  <Skeleton
                    width={120}
                    height={15}
                    style={{ marginLeft: 10, marginTop: 5, marginBottom: 5 }}
                  />
                  <Skeleton
                    width={20}
                    height={20}
                    borderRadius={10}
                    style={{ marginLeft: "auto" }}
                  />
                </View>
                <View style={styles.cardContent}>
                  <Skeleton width={90} height={20} />
                  <Skeleton
                    width={90}
                    height={20}
                    style={{ marginTop: 10, alignSelf: "flex-start" }}
                  />
                </View>
              </View>
            ) : (
              shouldShowDashboard(6) && (
                <View style={styles.cardSmall}>
                  <View style={styles.cardHeader}>
                    <Text
                      style={[
                        styles.cardTitle,
                        { marginLeft: 10, marginTop: 5 },
                      ]}
                    >
                      {flowStatusData?.title}
                    </Text>
                    <FontAwesome5
                      name="water"
                      size={16}
                      color="#009DF0"
                      style={{ marginLeft: "auto", marginTop: 5 }}
                    />
                  </View>
                  <View style={styles.flowCardContent}>
                    <View style={{ flexDirection: "row", gap: 4 }}>
                      <Text
                        style={[styles.flowCardValue, { color: "#009DF0" }]}
                      >
                        {flowStatusData?.actual_flow
                          ? Number(flowStatusData?.actual_flow)?.toFixed(0)
                          : 0}{" "}
                      </Text>
                      <Text style={styles.flowText}>m³/h (Actual)</Text>
                    </View>
                    <View style={{ flexDirection: "row", gap: 4 }}>
                      <Text
                        style={[
                          styles.flowCardValue,
                          { color: "#C4C4C4", marginLeft: 8 },
                        ]}
                      >
                        {flowStatusData?.total_flow
                          ? Number(flowStatusData?.total_flow)?.toFixed(0)
                          : 0}{" "}
                      </Text>
                      <Text style={styles.flowText}>m³/h (Nominal)</Text>
                    </View>
                  </View>
                </View>
              )
            )}
          </View>

          <View style={styles.chartsRow}>
            {/* Bar Chart - Dashboard ID: 11 (Daily Flow) */}

            {bargraphLoading ? (
              <View style={[styles.cardChart, { padding: 6 }]}>
                <View style={{ padding: 16 }}>
                  {/* Heading Skeleton */}
                  <Skeleton
                    width={220}
                    height={20}
                    borderRadius={6}
                    style={{ alignSelf: "center", marginBottom: 20 }}
                  />

                  {/* Chart Box Skeleton */}
                  <Skeleton
                    width={400}
                    height={200}
                    borderRadius={8}
                    style={{ marginBottom: 20, alignSelf: "center" }}
                  />
                </View>
              </View>
            ) : (
              shouldShowDashboard(11) && (
                <View style={[styles.cardChart, { padding: 6 }]}>
                  <Text style={[styles.cardTitle, { textAlign: "center" }]}>
                    {/* {
                      dashboardAccess.find((item) => item.dashboard_id === 11)
                        ?.dashboard_name
                    } */}
                    {barGraphData?.dashboard_name}
                  </Text>
                  <Victory.VictoryChart
                    theme={Victory.VictoryTheme.material}
                    domainPadding={{ x: 100 }}
                    width={screenWidth * 0.97}
                    height={550}
                    padding={{ top: 60, bottom: 50, left: 80, right: 30 }}
                  >
                    <Victory.VictoryLegend
                      x={screenWidth * 0.7}
                      y={-12}
                      orientation="horizontal"
                      gutter={20}
                      style={{
                        labels: { fontSize: 20, fontWeight: "600" },
                      }}
                      data={[
                        {
                          name: "Supplied",
                          symbol: {
                            fill: "#3498db",
                            type: "square",
                            size: 12,
                          },
                        },
                        {
                          name: "Demand",
                          symbol: {
                            fill: "#e67e22",
                            type: "square",
                            size: 12,
                          },
                        },
                      ]}
                    />
                    <Victory.VictoryGroup offset={50}>
                      <Victory.VictoryBar
                        data={barGraphData?.results}
                        x="formattedDate"
                        y="deliveryAmount"
                        barWidth={50}
                        style={{ data: { fill: "#3498db" } }}
                        labels={({ datum }) =>
                          `${formatValue(datum?.deliveryAmount?.toFixed(0))}`
                        }
                        labelComponent={
                          <Victory.VictoryLabel
                            dy={-10}
                            style={{
                              fontSize: 20,
                              fontWeight: "400",
                              fill: "#333",
                            }}
                          />
                        }
                      />
                      <Victory.VictoryBar
                        data={barGraphData?.results}
                        x="formattedDate"
                        y="descriptionTotal"
                        barWidth={50}
                        style={{ data: { fill: "#e67e22" } }}
                        labels={({ datum }) =>
                          `${formatValue(datum?.descriptionTotal?.toFixed(0))}`
                        }
                        labelComponent={
                          <Victory.VictoryLabel
                            dy={-10}
                            style={{
                              fontSize: 20,
                              fontWeight: "400",
                              fill: "#333",
                            }}
                          />
                        }
                      />
                    </Victory.VictoryGroup>
                    <Victory.VictoryAxis
                      style={{
                        axis: { stroke: "gray", strokeWidth: 1 },
                        grid: {
                          stroke: "lightgray",
                          strokeWidth: 1,
                          strokeDasharray: "0",
                        },
                        tickLabels: {
                          fontSize: 18, // change font size
                          fontWeight: "400", // bold font
                          fill: "#000", // text color
                        },
                      }}
                    />
                    <Victory.VictoryAxis
                      tickFormat={(t) => formatValue(t)}
                      dependentAxis
                      style={{
                        axis: { stroke: "gray", strokeWidth: 1 },
                        grid: {
                          stroke: "lightgray",
                          strokeWidth: 1,
                          strokeDasharray: "0",
                        },
                        tickLabels: {
                          fontSize: 18, // change font size
                          fontWeight: "400", // bold font
                          fill: "#000", // text color
                          paddingLeft: 15,
                          angle: -45,
                        },
                      }}
                      label="Volume (m³)"
                      axisLabelComponent={
                        <Victory.VictoryLabel
                          dy={-55}
                          style={{
                            fontSize: 16,
                            fontWeight: "400",
                            fill: "#000",
                            textAnchor: "middle",
                          }}
                        />
                      }
                    />
                  </Victory.VictoryChart>
                </View>
              )
            )}
            {/* SWITCH STATUS - Dashboard ID: 10 */}
            {switchLoading ? (
              <View style={[styles.cardChart, { flex: 0.178 }]}>
                <View>
                  <Skeleton
                    width={100}
                    height={20}
                    borderRadius={4}
                    style={{ alignSelf: "center", marginBottom: 15 }}
                  />

                  {/* Three Card Skeletons */}
                  {[1, 2, 3].map((_, index) => (
                    <Skeleton
                      width={160}
                      height={40}
                      borderRadius={8}
                      style={{ marginBottom: 10, alignSelf: "center" }}
                    />
                  ))}
                </View>
              </View>
            ) : (
              shouldShowDashboard(10) && (
                <View style={[styles.cardChart, { flex: 0.182 }]}>
                  <View style={styles.cardHeaderWithIcon}>
                    <Text style={[styles.cardTitle, { textAlign: "left" }]}>
                      {switchStatusData?.dashboard_name}
                    </Text>
                    <Image
                      style={{ width: 20, height: 20 }}
                      source={require("../../assets/images/Digitalinput3-8.jpg")}
                    />
                  </View>
                  <FlatList
                    data={switchStatusData?.resultArray}
                    renderItem={renderSwitchStatusItem}
                    keyExtractor={(item) => item.id}
                    style={styles.flatList}
                    scrollEnabled={true}
                    showsVerticalScrollIndicator={false}
                  />
                </View>
              )
            )}

            {/* WATER METER ALERTS - Dashboard ID: 7 */}
            {switchLoading ? (
              <View style={[styles.cardChart, { flex: 0.178 }]}>
                <View>
                  <Skeleton
                    width={100}
                    height={20}
                    borderRadius={4}
                    style={{ alignSelf: "center", marginBottom: 15 }}
                  />
                  {/* Three Card Skeletons */}
                  {[1, 2, 3].map((_, index) => (
                    <Skeleton
                      key={index}
                      width={160}
                      height={40}
                      borderRadius={8}
                      style={{ marginBottom: 10, alignSelf: "center" }}
                    />
                  ))}
                </View>
              </View>
            ) : (
              shouldShowDashboard(7) && (
                <View style={[styles.cardChart, { flex: 0.182 }]}>
                  <View style={styles.cardHeaderWithIcon}>
                    <Text
                      style={[styles.cardTitle]}
                      numberOfLines={1}
                      ellipsizeMode="tail"
                    >
                      {waterMeterData?.dashboard_name}
                    </Text>
                    <Image
                      style={{ width: 20, height: 20 }}
                      source={require("../../assets/images/Watermeter.png")}
                    />
                  </View>
                  <FlatList
                    data={waterMeterData?.waterLeakResponse}
                    renderItem={renderWaterMeterItem}
                    keyExtractor={(item) => item.id}
                    style={styles.flatList}
                    scrollEnabled={true}
                  />
                </View>
              )
            )}
          </View>

          <View style={[styles.chartsRow]}>
            {/* RTU List - Dashboard ID: 9 */}
            {shouldShowDashboard(9) && renderRTUListSection()}

            {/* Sensor Alerts - Dashboard ID: 8 */}
            {switchLoading ? (
              <View style={[styles.narrowCardChart, { marginLeft: 20 }]}>
                <View style={[styles.cardTitle, { textAlign: "center" }]}>
                  <Skeleton
                    width={140}
                    height={20}
                    borderRadius={4}
                    style={{ alignSelf: "center", marginBottom: 15 }}
                  />

                  {[1, 2, 3, 4].map((_, index) => (
                    <Skeleton
                      width={180}
                      height={40}
                      borderRadius={8}
                      style={{ marginBottom: 10, alignSelf: "center" }}
                    />
                  ))}
                </View>
              </View>
            ) : (
              shouldShowDashboard(8) && (
                <View style={[styles.narrowCardChart, { marginLeft: 8 }]}>
                  <View style={styles.cardHeaderWithIcon}>
                    <Text style={[styles.cardTitle]}>
                      {sensorData?.dashboard_name}
                    </Text>
                    <Image
                      style={{ width: 20, height: 20 }}
                      source={require("../../assets/images/sensorLogo.png")}
                    />
                  </View>
                  <FlatList
                    data={sensorData?.results}
                    renderItem={renderSensorAlertItem}
                    keyExtractor={(item) => item.id}
                    style={styles.flatList}
                    scrollEnabled={true}
                  />
                </View>
              )
            )}
          </View>
        </View>

        {/* Pie Chart - Dashboard ID: 5 */}
        {shouldShowDashboard(5) && (
          <View style={styles.pieCard}>
            {valveLoading ? (
              <View
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  paddingVertical: 20,
                }}
              >
                <Skeleton
                  width={180}
                  height={24}
                  borderRadius={4}
                  style={{ marginBottom: 10 }}
                />

                <Skeleton
                  width={100}
                  height={18}
                  borderRadius={4}
                  style={{ marginBottom: 20 }}
                />

                <Skeleton
                  width={150}
                  height={150}
                  borderRadius={100}
                  style={{ marginBottom: 20 }}
                />

                {/* Legend Skeletons */}
                {[1, 2, 3].map((_, idx) => (
                  <Skeleton
                    key={idx}
                    width={140}
                    height={18}
                    borderRadius={4}
                    style={{ marginBottom: 10 }}
                  />
                ))}
              </View>
            ) : valveData.length > 0 ? (
              <>
                <View style={styles.cardHeaderWithIconValve}>
                  <Text style={[styles.cardTitle, { textAlign: "center" }]}>
                    {valveDashboardName}
                  </Text>
                  <Image
                    style={{ width: 20, height: 20 }}
                    source={require("../../assets/images/valves.png")}
                  />
                </View>
                <Text style={styles.cardSub}>Total: {valveTotal}</Text>

                <View style={styles.chartContainer}>
                  <Pressable style={{ alignItems: "center" }}>
                    <Victory.VictoryPie
                      data={valveData}
                      colorScale={valveData.map((d) => d.color)}
                      innerRadius={0}
                      padAngle={2}
                      height={250}
                      width={250}
                      style={{ alignItems: "center" }}
                      labels={() => null}
                      events={[
                        {
                          target: "data",
                          eventHandlers: {
                            onClick: () => {
                              return [
                                {
                                  target: "data",
                                  mutation: (props) => {
                                    const clickedData = props.datum;
                                    if (clickedData) {
                                      navigation.navigate(
                                        "ValveDetailsReport",
                                        {
                                          status: clickedData.status,
                                          zoneId: ZoneValueId,
                                          subzoneId: SubzoneValueId,
                                        },
                                      );
                                    }
                                    return null;
                                  },
                                },
                              ];
                            },
                          },
                        },
                      ]}
                    />
                  </Pressable>
                </View>
                <View style={styles.legendContainer}>
                  {valveData.map((item, idx) => (
                    <TouchableOpacity
                      key={idx}
                      style={styles.legendRow}
                      onPress={() => {
                        navigation.navigate("ValveDetailsReport", {
                          status: item.status,
                          zoneId: ZoneValueId,
                          subzoneId: SubzoneValueId,
                        });
                      }}
                    >
                      <View
                        style={[
                          styles.colorBox,
                          { backgroundColor: item.color },
                        ]}
                      />
                      <Text style={styles.legendText}>
                        {item.y} {item.x}
                      </Text>
                    </TouchableOpacity>
                  ))}
                </View>
              </>
            ) : (
              <View
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  flex: 1,
                }}
              >
                <Text style={styles.noDataText}>No valve data available</Text>
              </View>
            )}
          </View>
        )}
      </View>
    </View>
  );
};

const Skeleton = ({ width, height, borderRadius = 4, style = {} }) => {
  const animatedValue = useRef(
    Animated && Animated.Value
      ? new Animated.Value(0)
      : { interpolate: () => 0 },
  ).current;

  useEffect(() => {
    Animated.loop(
      Animated.timing(animatedValue, {
        toValue: 1,
        duration: 1500,
        useNativeDriver: false,
      }),
    ).start();
  }, [animatedValue]);

  const translateX = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: [-width, width],
  });

  return (
    <View
      style={[
        {
          width,
          height,
          borderRadius,
          backgroundColor: "#f0f0f0",
          overflow: "hidden",
        },
        style,
      ]}
    >
      <Animated.View
        style={[
          StyleSheet.absoluteFill,
          {
            transform: [{ translateX }],
          },
        ]}
      >
        <View
          style={{
            flex: 1,
            width: "100%",
            backgroundColor: "#e0e0e0",
            opacity: 0.6,
          }}
        />
      </Animated.View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 10,
  },
  dropdown: {
    borderColor: "#c3c3c3",
    borderWidth: 1,
    borderRadius: 2,
    height: 30,
    padding: 10,
    marginTop: 5,
  },
  item: {
    padding: 12,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  textItem: {
    fontSize: 14,
  },
  placeholderStyle: {
    fontSize: 14,
  },
  selectedTextStyle: {
    fontSize: 14,
  },
  iconStyle: {
    width: 20,
    height: 20,
  },
  inputSearchStyle: {
    height: 40,
    fontSize: 14,
    outlineStyle: "none",
  },
  row: {
    flexDirection: "row",
    flex: 1,
    marginTop: 10,
  },
  cardsRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  chartsRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  columnContainer: {
    width: "25%",
    flexDirection: "column",
  },
  dataTableContainer: {
    height: 280,
    overflow: "hidden",
  },
  statusCell: {
    justifyContent: "center",
    alignItems: "center",
  },
  statusText: {
    fontSize: 10,
    fontWeight: "700",
  },
  lastConnectionContainer: {
    alignItems: "center",
    marginTop: 2,
  },
  lastConnectionDate: {
    fontSize: 10,
    color: "#333",
    fontWeight: "700",
  },
  lastConnectionTime: {
    fontSize: 10,
    color: "#333",
    fontWeight: "700",
  },
  cardSmall: {
    flex: 0.26,
    backgroundColor: "#fff",
    marginHorizontal: 6,
    paddingRight: 6,
    paddingLeft: 6,
    paddingTop: 2,
    borderRadius: 8,
    shadowColor: "#000",
    shadowOpacity: 0.25,
    shadowOffset: { width: 0, height: 1 },
    shadowRadius: 4,
    elevation: 4,
    alignItems: "flex-start",
    height: 90,
  },
  // flowCard: {
  //   width:"40%"
  // },
  cardHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
  },
  cardContent: {
    flexDirection: "column",
    alignItems: "center",
    marginLeft: 10,
  },
  // Special content for flow card
  flowCardContent: {
    flexDirection: "column",
    alignItems: "center",
    marginLeft: 2,
  },
  flowCardValue: {
    fontSize: 18,
    fontWeight: "700",
    textAlign: "center",
    marginBottom: 2,
  },
  flowCardSubValue: {
    fontSize: 10,
    color: "gray",
    textAlign: "center",
    marginBottom: 4,
  },
  flowCardPercent: {
    fontSize: 12,
    color: "#fff",
    fontWeight: "600",
  },
  pieCard: {
    flex: 0.2,
    backgroundColor: "#fff",
    marginLeft: 6,
    height: 382,
    // height: Dimensions.get("window").height * 0.71,
    borderRadius: 8,
    shadowColor: "#000",
    shadowOpacity: 0.25,
    shadowOffset: { width: 0, height: 1 },
    shadowRadius: 4,
    elevation: 4,
    alignItems: "center",
  },
  cardChart: {
    flex: 0.63,
    backgroundColor: "#fff",
    marginHorizontal: 6,
    padding: 6,
    borderRadius: 8,
    shadowColor: "#000",
    shadowOpacity: 0.25,
    shadowOffset: { width: 0, height: 1 },
    shadowRadius: 4,
    elevation: 4,
    height: 282,
    marginTop: 3,
    // height: Dimensions.get("window").height * 0.52,
  },
  wideCardChart: {
    width: "98%",
    backgroundColor: "#fff",
    marginHorizontal: 8,
    padding: 8,
    borderRadius: 8,
    shadowColor: "#000",
    shadowOpacity: 0.25,
    shadowOffset: { width: 0, height: 1 },
    shadowRadius: 4,
    elevation: 4,
    marginTop: 3,
    marginBottom: 6,
  },
  rtuSearchContainer: {
    marginBottom: 10,
  },
  rtuSearchInput: {
    borderColor: "#c3c3c3",
    borderWidth: 1,
    borderRadius: 4,
    height: 30,
    width: "40%",
    paddingHorizontal: 10,
    fontSize: 12,
    backgroundColor: "#fff",
  },
  controllerCell: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 1,
    paddingLeft: 2,
  },
  wifiIcon: {
    marginLeft: "-4",
    marginRight: 6,
  },
  controllerText: {
    fontSize: 10,
    fontWeight: "800",
    color: "#333",
    textAlign: "left",
  },
  combinedScrollContainer: {
    flex: 1,
    maxHeight: 45,
  },
  badgeScrollContainer: {
    width: "100%",
    overflowX: "auto", // enable horizontal scroll
    overflowY: "hidden",
    paddingBottom: 4,
  },
  badgeRow: {
    flexDirection: "row",
    gap: 8,
    minWidth: "100%",
  },
  badgeContainerWithCustomScroll: {
    // Styles to make it a horizontally scrolling container
    flexDirection: "row",
    overflowX: "auto", // Important: enables horizontal scrolling
    paddingBottom: 5,
  },
  combinedScrollContent: {
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
    paddingHorizontal: 2,
    paddingVertical: 8,
  },
  badge: {
    backgroundColor: "#f5f5f5",
    paddingVertical: 3,
    paddingHorizontal: 4,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: "#ddd",
    alignItems: "center",
    minWidth: 65,
    flexShrink: 0,
    marginRight: 4,
  },
  badgeLabel: {
    fontSize: 7,
    fontWeight: "500",
    color: "#2c3e50",
    textAlign: "center",
    textTransform: "uppercase",
  },
  badgeValue: {
    fontSize: 8,
    fontWeight: "400",
    color: "#2c3e50",
    textAlign: "center",
    marginTop: 0, // No margin
  },
  narrowCardChart: {
    width: "20%",
    backgroundColor: "#fff",
    padding: 8,
    borderRadius: 8,
    shadowColor: "#000",
    shadowOpacity: 0.25,
    shadowOffset: { width: 0, height: 1 },
    shadowRadius: 4,
    elevation: 4,
    marginBottom: 8,
  },
  // cardTitle: {
  //   fontSize: 14,
  //   fontWeight: "700",
  //   textAlign: "center",
  //   marginBottom: 2,
  //   color: "#303030",
  //   textTransform: "uppercase"
  // },
  cardTitle: {
    fontSize: 11,
    fontWeight: "700",
    textAlign: "left",
    marginBottom: 2,
    color: "#303030",
    flexShrink: 1,
  },
  cardSub: {
    fontSize: 15,
    color: "gray",
    textAlign: "center",
    marginTop: 2,
  },
  cardValue: {
    fontSize: 22,
    fontWeight: "bold",
    color: "#3498db",
  },
  cardPercent: {
    fontSize: 14,
    color: "#fff",
    fontWeight: "600",
  },
  chartContainer: {
    justifyContent: "center",
    alignItems: "center",
    marginTop: -30,
  },
  legendContainer: {
    marginTop: -15,
  },
  legendRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 6,
  },
  colorBox: {
    width: 16,
    height: 16,
    borderRadius: 12,
    marginRight: 8,
  },
  legendText: {
    fontSize: 12,
    color: "#333",
  },
  batteryView: {
    height: 22,
    backgroundColor: "red",
    borderRadius: 12,
    marginTop: 6,
    paddingLeft: 10,
    paddingRight: 10,
    alignItems: "center",
    justifyContent: "center",
  },
  flatList: {
    flex: 1,
    marginTop: 8,
  },
  waterMeterItem: {
    flexDirection: "column",
    alignItems: "flex-start",
    backgroundColor: "#FFFCF7",
    padding: 4,
    height: "auto",
    borderRadius: 8,
    marginBottom: 8,
    borderLeftWidth: 2,
    borderLeftColor: "#FFD700",
    paddingBottom: 6,
  },
  iconContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    gap: 5,
  },
  waterMeterTitle: {
    fontSize: 14,
    fontWeight: "700",
    color: "grey",
    marginBottom: 4,
    fontStyle: "italic",
    textAlignVertical: "center",
    textTransform: "uppercase",
  },
  alertRow: {
    flexDirection: "row",
    alignItems: "flex-start",
  },
  alertType: {
    fontSize: 14,
    color: "#333",
    marginRight: 12,
    fontWeight: "700",
    textTransform: "capitalize",
  },
  alertValue: {
    fontSize: 14,
    fontWeight: "700",
    color: "#333",
  },
  flowText: {
    fontSize: 10,
    color: "#C4C4C4",
    marginTop: 6,
    fontWeight: "400",
  },
  pieChartLoader: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    borderRadius: 8,
  },
  cardHeaderWithIcon: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 8,
    gap: 10,
    // width: "90%",
  },
  cardHeaderWithIconValve: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 8,
    gap: 10,
    marginTop: 5,
    width: "90%",
  },
  headerContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 10,
  },
  dropdownContainer: {
    flexDirection: "row",
    flex: 1,
    zIndex: 999,
  },
  reloadButton: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#3498db",
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 6,
    marginLeft: 10,
    marginTop: 5,
    height: 30,
  },
  reloadText: {
    color: "#fff",
    marginLeft: 5,
    fontSize: 12,
    fontWeight: "500",
  },
});

export default HomeScreen;
